import React from "react";
import { Home } from "./Home";
import { Solutions } from "./Solutions";
import { Dermaroller } from "./Dermaroller";
import { Lllt } from "./LLLT";
import { Recap } from "./Recap";
// import Contact from "./Contact";

export const Main = () => (
  //   <main>
  <div>
    <Home />
    <Solutions />
    <Dermaroller />
    <Lllt />
    <Recap />
    {/* <Contact /> */}
  </div>
  //   </main>
);

// export default Main;
